import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';
import '../styles/ImageSliderSection.css';
import { useTranslation } from 'react-i18next';

import Img1 from '../assets/images/g1.webp';
import Img2 from '../assets/images/g2.jpeg';
import Img3 from '../assets/images/g3.webp';
import Img4 from '../assets/images/g4.jpeg';
import Img5 from '../assets/images/g5.webp';
import Img6 from '../assets/images/galary10.jpeg';
import Img7 from '../assets/images/g7.png';
import Img8 from '../assets/images/g2.webp';
import Img9 from '../assets/images/g10.jpeg';



const images = [Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8, Img9];

export default function ImageSliderSection() {
    const { t } = useTranslation();

    return (
        <section className="bg-black">
            <h3 className="fade-up">{t('imageSlider.subtitle')}</h3>
            <h2 className="fade-up" dangerouslySetInnerHTML={{ __html: t('imageSlider.title') }} />


            <Swiper
                modules={[Autoplay]}
                autoplay={{ delay: 3000 }}
                spaceBetween={10}
                slidesPerView={3}
                loop={true}
            >
                {images.map((img, i) => (
                    <SwiperSlide key={i}>
                        <img src={img} alt={`dish-${i}`} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}
